import { render } from "./AuthModal.vue?vue&type=template&id=61863a1e&scoped=true"
import script from "./AuthModal.vue?vue&type=script&lang=js"
export * from "./AuthModal.vue?vue&type=script&lang=js"

import "./AuthModal.vue?vue&type=style&index=0&id=61863a1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61863a1e"]])

export default __exports__